<template>
		<div id="carousel">
            <Carousel3d  :disable3d="true" :space="330" :clickable="false" :controls-visible="true" :width="300" :height="560">

                <Slide v-for="(data,key) in arraydata" :key="key" :index="key">

                    <router-link v-if="link" :to="{name:'ProductDetail', params:{id:data.id,type:type}}">
                    <img :src="getImage(data)" :class="{'noImage':!hasImage(data)}" alt="">
                        <div class="carousel-title">
                            <h3 v-if="data.title">{{data.title}}</h3>
                            <h3 v-if="data.name">{{data.name}}</h3>

                        </div>
                    </router-link>
                    <div v-else>
                    <img :src="getImage(data)" :class="{'noImage':!hasImage(data)}" alt="">
                        <div class="carousel-title">
                            <h3 v-if="data.title">{{data.title}}</h3>
                            <h3 v-if="data.name">{{data.name}}</h3>
                        </div>
                    </div>
                    <button  v-if="link && !isFavorite(data)"  class="btn__favorite" @click="()=>addToCart(data,type)"> Ajouter au Favoris </button>
                    <button  v-if="link && isFavorite(data)"  class="btn__favorite isFavorite">  Favoris </button>
                    <router-link v-if="link && isFavorite(data)" to="/cart">
                        <button  class="btn__favorite isFavorite goFavorite">  Voir Favoris </button>
                    </router-link>
                </Slide>
            </Carousel3d>
           
        </div>
</template>

<script>
    import Button from "../components/Button";
	import ApiProducts from "@/mixins/ApiProducts";
    import {Carousel3d, Slide} from 'vue-carousel-3d';

    export default {
		name: "Carousel",
        props:{
          arraydata:Array,
            type:String,
            link:Boolean
        },
        components: {
            Carousel3d,
            Slide,
            Button
        },
        data: function () {
            return {
            
            }
        },
        mounted() {
        
        },
        methods: {
            addToCart: function (data,type) {
                this.$store.commit('addToCart', {data,type} )
            },
            getImage(data) {
                let url = 'img/logo_giant.png';
                if (data.poster_path) {
                    url = 'https://image.tmdb.org/t/p/w500' + data.poster_path + '?api_key=07b774c956a772a71371e0875cfec69e';
                }
                if(data.profile_path){
                    url = 'https://image.tmdb.org/t/p/w500' + data.profile_path + '?api_key=07b774c956a772a71371e0875cfec69e';

                }
                return url
            },
            isFavorite(data){
                if(this.$store.state.cart.length > 0){
                    let name = data.title ? data.title : data.name;
                    return this.$store.state.cart.some(el=>el.title === name)
                }
            },
            hasImage(data){
                return (data.poster_path || data.profile_path)
            }
        
        },
    
        mixins: [ApiProducts]
		
	}
</script>

<style lang="scss" scoped>
 
	#nav {
		display: flex;
		flex: 1;
		justify-content: space-between;
		padding: 5px 20px;
        align-items: center;
		position: relative;
		
		a {
			font-weight: bold;
			display: block;
			padding: 20px;
			
		}
		.main{
            display: flex;
            align-items: center;
        }
		.logo {
            padding: 0 10px;
            /*z-index: 100;*/
		}
        .search__form{
        
        }
        .search_container{
            display: flex;
            position:relative;
            right:20px;
            align-items: center;
        }
		
		#menuToggle {
			display: block;
			position: relative;
			
			z-index: 1;
			
			-webkit-user-select: none;
			user-select: none;
		}
        #menuK{
            
            display: block;
            position: relative;
    padding:10px;
            
            z-index: 1;
    
            -webkit-user-select: none;
            user-select: none;
        }
		
		#menuToggle a,#menuK a {
			text-decoration: none;
			color: #e5e5e5;
			
			transition: color 0.3s ease;
		}
		
		#menuToggle a:hover ,#menuK a:hover{
			color: tomato;
		}
		
		
		#menuToggle input{
			display: block;
			width: 40px;
			height: 32px;
			position: absolute;
			top: -7px;
			left: -5px;
			
			cursor: pointer;
			
			opacity: 0; /* hide this */
			z-index: 2; /* and place it over the hamburger */
			
			-webkit-touch-callout: none;
		}
    
    #menuK input{
        display: block;
        width: 10px;
        height: 32px;
        position: absolute;
        top: 0px;
        left: 4px;
    
        cursor: pointer;
        
        opacity: 0; /* hide this */
        z-index: 2; /* and place it over the hamburger */
        
        -webkit-touch-callout: none;
    }
		
		/*
		 * Just a quick hamburger
		 */
		#menuToggle span{
			display: block;
			width: 30px;
			height: 3px;
			margin-bottom: 5px;
			position: relative;
			
			background: #e5e5e5;
			
			z-index: 1;
			
			transform-origin: 4px 0px;
			
			transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
			background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
			opacity 0.55s ease;
		}
        #menuK span {
            display: block;
            width: 4px;
            border-radius:100%;
            height: 4px;
            margin-bottom: 5px;
            position: relative;
    
            background: #e5e5e5;
            
            z-index: 1;
            
            transform-origin: 4px 0px;
            
            transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
            background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0),
            opacity 0.55s ease;
        }
		
		#menuToggle span:first-child,#menuK span:first-child{
			transform-origin: 0% 0%;
   
		}
		
		#menuToggle span:nth-last-child(2),#menuK span:nth-last-child(2) {
			transform-origin: 0% 100%;
   
		}
		
		/*
		 * Transform all the slices of hamburger
		 * into a crossmark.
		 */
		#menuToggle input:checked ~ span,#menuK input:checked ~ span {
			opacity: 1;
			transform: rotate(45deg) translate(-2px, -2px);
			background: #e5e5e5;
            height: 3px;
            width: 30px;
            border-radius: 0;
        }
		
		/*
		 * But let's hide the middle one.
		 */
		#menuToggle input:checked ~ span:nth-last-child(3), #menuK input:checked ~ span:nth-last-child(3) {
			opacity: 0;
			transform: rotate(0deg) scale(0.2, 0.2);
        
        }
		
		/*
		 * Ohyeah and the last one should go the other direction
		 */
		#menuToggle input:checked ~ span:nth-last-child(2),#menuK input:checked ~ span:nth-last-child(2) {
			transform: rotate(-45deg) translate(2px,0px);
            height: 3px;
            width: 30px;
            border-radius: 0;
		}
		
		/*
		 * Make this absolute positioned
		 * at the top left of the screen
		 */
		#menu{
			position: absolute;
			margin: -50px 0 0 -30px;
			height: 100vh;
            padding:0;
			background: #0d0d0d;
			list-style-type: none;
			-webkit-font-smoothing: antialiased;
			/* to stop flickering of text in safari */
			
			transform-origin: 0% 0%;
			transform: translate(-100%, 0);
			transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0);
   .menuList{
       margin-top: 80px;
   }
		}
    #menuKL{
        position: absolute;
        top:-50px;
        left:-110px;
        padding:20px;
        padding-top: 80px;
    
        background: #0d0d0d;
        list-style-type: none;
        -webkit-font-smoothing: antialiased;
        /* to stop flickering of text in safari */
        transform-origin: 0% 0%;
        transform: translate(0%, -100%);
    
        transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1.0);
    }
		
		#menu li {
			padding: 10px 0;
			font-size: 22px;
		}
		
		/*
		 * And let's slide it in from the left
		 */
		#menuToggle input:checked ~ ul, #menuK input:checked ~ ul{
			transform: none;
		}
	}
    .carousel-3d-container{
        height: 600px !important;
    }
    .carousel-3d-slide {
        border-radius: 10px;
        background-color:#232323;
        box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 15px 0 rgba(0, 0, 0, 0.19);

        :hover{
            cursor: pointer;
        }

        img{
            width: 100%;
            height: auto;
            min-height: 450px;
        }
        h3{
            color: #fff;
            position: relative;
            bottom: 0px;
            left: 10px;
            margin-top: 10px;
            font-size: 1.2em;
        }
        .btn__favorite{
            display:block;
            border:1px solid #fff;
            border-radius:5px;
            padding:4px;
            width:140px;
            background-color: #232323;
            color: #fff;
            position: relative;
            bottom: 10px;
            margin: 0 auto;
            transition: 0.3s
        }
        .btn__favorite:hover{
            cursor: pointer;
            background-color: #fff ;
            color: #9c0204;
        }
        .isFavorite{
            border:1px solid green;
            background-color: green ;
            color: #fff;
            display: inline-block;
            width: 80px;
            margin-right: 20px;
            margin-left: 20px;
        }
        .isFavorite:hover{
            border:1px solid green;
            background-color: green ;
            color: #fff;
            font-size: 13px;
        }
        .goFavorite{
            border:1px solid #fff;
            background-color: #232323;
            color: #fff;
            width: 140px;
        }
        .btn__delete{

            border:1px solid #fff;
            color: #fff;
            transition: 0.3s
        }
        .btn__delete:hover{

            background-color: #fff;
            color: #9c0204;
        }
      a{
          text-decoration: none;
      }
        .noImage{
            padding:175px 0;
            min-height: 0;
        }
    }
</style>